const now = new Date();
export const defaultConfigState = {
  TwoFAInfo: {},
  /**
   * Cờ đang xử lý
   */
  Loading: false,
  /**
   * Token đăng nhập
   */
  Token: null,
  /**
   * Thời điểm  token hết hạn
   */
  TokenExpired: null,
  /*
   * Trạng thái Collapse của left menu
   */
  LeftMenuCollapse: false,
  /**
   * Thông tin phân quyền
   * Key là subsystemCode, value sẽ là mảng string danh sách perrmission
   */
  Permission: {},
  /**
   * Thông tin thuê bao
   */
  License: {},
  /**
   * Thông tin tài khoản
   */
  User: {
    UserID: null,
    Email: null,
    FullName: null,
    Mobile: null,
    UserName: null,
    PartnerId: null,
  },
  /**
   * Thông tin config
   */
  ConfigInfo: {
    CurrentDate: new Date(now.getFullYear(), now.getMonth(), now.getDay()),
    CurrentDateText: '',
  },
  /**
   * Định dạng số
   */
  NumberFormat: {
    GeneralDecimalSeparator: '.',
    GeneralGroupSeparator: ',',
    QuantityDecimalDigits: 2,
    AmountDecimalDigits: 0,
    AmountOCDecimalDigits: 2,
    UnitPriceDecimalDigits: 2,
    UnitPriceOCDecimalDigits: 2,
    ExchangRateDecimalDigits: 2,
    CoefficientDecimalDigits: 2,
    AllocationDecimalDigits: 2,
  },
  OptionsData: {},
  /**
   * Ngôn ngữ hiện tại
   */
  Culture: 'en-US',
  /**
   * Ngày hạch toán
   */
  PostedDate: new Date(),
  /**
   * Một số thông tin liên quan đến phiên làm việc hiện tại
   * Chỉ có 1 số thông tin ở đây, 1 số thông tin khi submit lên server sẽ lấy từ token: userid, databaseid, tenantid...
   */
  Context: {},
  CachePaging: {
    IndexPage: 1,
    FilterObject: '',
    SearchKey: '',
    SelectValue: '',
    FilterTag: '',
  },
  DeviceID: null,
  TicketCount: 0,
  RequestCount: 0,
  ReloadNotification: 0,
  /**
   * Date format preference (DD/MM/YYYY or MM/DD/YYYY)
   * @created by lvduy
   * @createdDate 2026-06-18
   */
  DateFormat: 'DD/MM/YYYY',
};

export default {
  ...defaultConfigState,
};
